export default "__VITE_ASSET__Cf51L_6c__"